import {StoreState} from '@/app/store';

export const selectLocationFullName = (state: StoreState) => {
	if (!state.weather.data) {
		return undefined;
	}

	const location = state.weather.data.location;
	if (!location) {
		return '';
	}

	const {title, description} = location;
	return description ? `${title}, ${description}` : title;
};

export const selectForecastData = (state: StoreState) => state.weather.data;
export const selectForecastLanguage = (state: StoreState) => state.weather.data?.language;
export const selectForecastLocation = (state: StoreState) => state.weather.data?.location;
export const selectForecastLocationId = (state: StoreState) => state.weather.data?.location.id;
export const selectForecastLocationAlternateIds = (state: StoreState) => state.weather.data?.locationMeta?.alternateIds;
export const selectForecastLocationStableId = (state: StoreState) => {
	return {
		id: state.weather.data?.locationMeta?.stableId,
		countryId: state.weather.data?.locationMeta?.countryStableId,
	};
};
export const selectForecastLocationTimezone = (state: StoreState) => ({
	name: state.weather.data?.location.timezoneName,
	offset: state.weather.data?.location.timezoneOffset,
});

export const selectForecastViewParams = (state: StoreState) => {
	const {daysMode, selectedDate, selectedWeekday} = state.weather.view;
	const {forecast} = state.weather.data!;
	let selectedDay = 0;
	if (selectedDate) {
		selectedDay = forecast.findIndex(day => day.date === selectedDate);
	} else if (selectedWeekday !== undefined) {
		selectedDay = forecast.findIndex(day => {
			let date = new Date(day.date);
			date = new Date(date.getTime() + date.getTimezoneOffset() * 60 * 1000);
			return date.getDay() === selectedWeekday;
		});
	} else {
		const nowDayIndex = forecast.findIndex(day => day.now);
		if (nowDayIndex !== -1) {
			selectedDay = nowDayIndex;
		}
	}
	return {daysMode, selectedDay, selectedDate, selectedWeekday};
};
